












import Component from 'vue-class-component';
import {DiscardConfirmDialogRequest} from '@/model/CommonModel';
import '@/plugins/Modal';
import {Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';

@Component({
    mixins: [DialogEventsMixin],
    components: {CommonButton, CommonPromptDialog}
})
export default class DiscardConfirmDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
    private dialogVisible = false;
    private onConfirm: any;

    get isVisible() {
        return this.dialogVisible;
    }

    set isVisible(param) {
        this.dialogVisible = false;
    }

    public onOk() {
        if (typeof this.onConfirm === 'function') {
            this.onConfirm({
                result: true
            });
            this.hide();
        } else {
            this.hide();
        }
    }

    public onCancel() {
        this.hide();
    }

    public show(params: DiscardConfirmDialogRequest) {
        this.dialogVisible = true;
        const {onConfirm} = params;
        this.onConfirm = onConfirm;
        this.$store.commit('setVisibleDiscardConfirmDialog', true);
    }

    public hide() {
        this.dialogVisible = false;
        this.$store.commit('setVisibleDiscardConfirmDialog', false);
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showDiscardConfirmDialog', (params: DiscardConfirmDialogRequest) => {
                this.show(params);
            });
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showDiscardConfirmDialog');
    }
}
